import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "../../services/api.service";

/** Note: requires the [size] attribute to be passed */
@Component({
    selector: "ngx-article-preview[size][articleData]",
    templateUrl: "./article-preview.component.html",
    styleUrls: ["./article-preview.component.scss"],
})
export class ArticlePreviewComponent implements OnInit {
    @Input("articleData") articleData: any;
    @Input("size") previewSize: string;
    @Input("contractAddress") contractAddress: string;
    constructor(private _router: Router) {}

    ngOnInit(): void {}

    onReadMore(articleID: number) {
        this._router.navigate([this.contractAddress, "blog", articleID]);
    }
}
